import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient,HttpParams, HttpHeaders } from '@angular/common/http';
import { Subscription,Observable } from 'rxjs';
import * as firebase from 'firebase';
import { query } from '@angular/animations';
import { rejects } from 'assert';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  currentUrl:string;
  popup = new EventEmitter();
  bgBodyEmitter = new EventEmitter();
  slidePositionEmmiter = new EventEmitter();
  
  updatedDevicesEventEmitter:EventEmitter<any> = new EventEmitter(); 
  Storage = localStorage;
  devicesStore:any;
  devicesClone:any;
  manufacturersStore:any;
  manufacturersClone:any;
  FIREBASE_REGION = "europe-west1";
  logoBaseUrl = 'https://electric-space-abbde.web.app/assets/images/manufacturers/';

  constructor(private http:HttpClient) {
    this.Storage.removeItem("categories");
    this.Storage.removeItem("manufacturers");
    this.Storage.removeItem("devices");
    this.Storage.removeItem("periods");
    this.Storage.removeItem("stores");
    this.Storage.removeItem("models");
}

  bgBodyOn(element){
  element.style.display = 'block'
  element.classList.remove('bgBodyOff');
  element.classList.add('bgBodyOn');
  }

  bgBodyOff(element){
  element.classList.remove('bgBodyOn');
  element.classList.add('bgBodyOff');
  setTimeout(()=>{
    element.style.display = 'none' 
  },500)
  }


  post(api,body){
    let baseUrl = 'http://localhost:3000/';
   
    let url = baseUrl + api;
    return this.http.post(url,body)
  }

  get(api:string,params?:any){
    let baseUrl = 'http://localhost:3000/';
    let httpParams:HttpParams = new HttpParams();

    // if(api.indexOf('list')!=-1)
    //   baseUrl = 'https://q0jtvd36j2.execute-api.eu-west-1.amazonaws.com/dev/' 

    // else
    //   baseUrl = 'http://localhost:3000/'
    
    if(params){
      Object.keys(params).forEach( key =>{
        httpParams = httpParams.append(key,params[key])
      })
    }

    let url = baseUrl + api;
    return this.http.get(url,{params: httpParams});
    
  } 

  fromServer(firebaseFuncName:string,query?:any) {
    return new Promise((resolve, reject) => {
      console.log("FIREee",firebase.app())
        let func = firebase.app().functions(this.FIREBASE_REGION).httpsCallable(firebaseFuncName);

        func(query).then(result => {
          let data = result.data;
          resolve(data);
        })
        .catch(err => {
            console.log("Storage.fromServer: " + firebaseFuncName, err)
        })
    })
  }


  ratingFromServer(firebaseFuncName:string,query?:any){

    return new Promise((resolve, reject) => {
      let func = firebase.app().functions('europe-west3').httpsCallable(firebaseFuncName);

      func(query).then(result => {
        let data = result.data;
        resolve(data);
      })
      .catch(err => {
          console.log("Storage.fromServer: " + firebaseFuncName, err)
      })
  })

  }



  deleteDevice(device){
    return new Promise(async (resolve,reject)=>{
      let devices = JSON.parse(this.Storage.getItem("devices"));
      for (let i = 0; i < devices.length; i++){
        if(device._id == devices[i]._id){
          devices[i].show = false;
          this.updateDevicesList(devices);
          this.Storage.setItem("devices",JSON.stringify(devices)); 
          resolve({status:1});
          try{
            let result:any = await this.fromServer("hideDevice",{_id:device._id});
          }
          catch(err){
            console.log('global.deletedevice' + err.message);
            reject(err)
          }
          return;
        }
      }
    })
  }

  saveDevice(device:any){

    return new Promise(async(resolve,reject)=>{
      let devices = JSON.parse(this.Storage.getItem("devices"));
      
      if(devices){
        if (device._id){
          devices.forEach((deviceItem,index)=>{
            if(deviceItem._id == device._id){
              devices.splice(index, 1, device)  
            }
          })
        }
        else
          devices.push(device);

        // this.updateDevicesList(devices);
        resolve(devices);   
      }

      try{
        let result:any = await this.fromServer('saveDevice',device);
        devices = await this.fromServer("devices");
        // this.updateDevicesList(devices)
        this.Storage.setItem('devices',JSON.stringify(devices))
        
      }
      catch(err){
        console.log('global.saveDevice' + err);
        reject(err);
      } 
    })
    
  }

  async getDevices(){
    let devices:any ;
    devices = this.Storage.getItem("devices");
    if(devices){
      this.updateDevicesList(JSON.parse(devices))
    }

    try{
      devices = await this.fromServer("devices");
      this.updateDevicesList(devices)
      this.Storage.setItem('devices',JSON.stringify(devices)) 
    }
    
    catch(err){
      console.log("global.getDevices" + err);
      if(!devices)
        this.updatedDevicesEventEmitter.emit([]);
    } 
  }

  updateDevicesList(devices){
    let devicesClone = devices.map(device => ({...device}));
    this.updatedDevicesEventEmitter.emit(devicesClone); 
  }

  getDataList(listName:string,query){
    return new Observable(subscriber=>{
      
      let data:any = this.Storage.getItem(query.collectionName);
      if(data){
        subscriber.next(JSON.parse(data));
      }

      this.fromServer(listName,query).then((result:any)=>{
        let data = result.items;
        this.Storage.setItem(listName,JSON.stringify(data));
        subscriber.next(data);
        subscriber.complete();
        
      },
      error=>{
        console.log('global.getDataList: ' + error);
        subscriber.complete();
        throw new Error(error)
      });
    })

  }


  getItem(id:string,firebaseFuncName:string,query?:any){
    
    return new Promise(async(resolve,reject) => {
      try{
      let list = JSON.parse(this.Storage.getItem(query.collectionName));
      if(!list){
        let listData:any = await this.fromServer(firebaseFuncName,query);
        list = listData.items;
        this.Storage.setItem(query.collectionName,JSON.stringify(list))    
      }
      if(!list){
        console.log(`List is empty`);
        resolve(null);
        return;
      }
      let item = list.find(listItem => listItem._id == id)
      resolve(item)
    }
      catch(err){
        console.log("global.getItem: " + err);
        reject(err)
      }
    })
    
  }

  getDevice(id:string){
    
    return new Promise(async(resolve,reject) => {
      try{
      let list = JSON.parse(this.Storage.getItem("devices"));
      if(!list){
        list = await this.fromServer("devices")
        this.Storage.setItem("devices",JSON.stringify(list))    
      }
      if(!list){
        console.log(`List is empty`);
        resolve(null);
        return;
      }
      let item = list.find(listItem => listItem._id == id)
      resolve(item)
    }
      catch(err){
        console.log("global.getDevice: " + err);
        reject(err)
      }
    })
    
  }


  
  
  


}
